<div [class]="'layout-row ' + vAlignment + '-xs ' + hAlignment + '-xs'">
  <div class="layout-panel" [class.layout-panel-fluid]="columnCount >= 8 && columnCount < 12 && !preset"
    [style.--layout-width]="panelWidth"
    [style.--layout-max-width]="panelMaxWidth">

    <main>
      <div class="layout-header">
        @if (title) {
          <div class="layout-title" [ngStyle]="{ 'text-align': title.align }">
            <ng-content select="app-layout-title"></ng-content>
          </div>
        }

        @if (actions) {
          <div [ngStyle]="{ 'align-self': actions.align }" class="layout-actions">
            <ng-content select="app-layout-actions"></ng-content>
          </div>
        }
      </div>

      <div class="layout-content">
        <ng-content select="app-layout-content"></ng-content>
      </div>
    </main>

  </div>
</div>
